import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/shop/:slug',
      name: 'shop',
      component: Home,
    },
    {
      path: '/deak-gergely',
      name: 'deak',
      component: () => import(/* webpackChunkName: "about" */ './views/Article.vue'),
    },
    {
      path: '/csorbics-benjamin',
      name: 'csorbics',
      component: () => import(/* webpackChunkName: "about" */ './views/Article.vue'),
    },
    {
      path: '/suto-laszlo',
      name: 'suto',
      component: () => import(/* webpackChunkName: "about" */ './views/Article.vue'),
    },
  ],
});
